import Component from '@galactic-advisors/component-loader';

const DEFAULTS = {
  modalCloseButtonElement: '[data-modal-close-button]',
  formElement: '[data-feature-evidence-form]',
};

export default class AddFeatureEvidenceModal extends Component {
  static selector = '[data-comp-add-feature-evidence-modal]';

  constructor(containerEl, options = DEFAULTS) {
    super(containerEl, options);

    this.modalCloseButton = this.$container.querySelector(
      this.$options.modalCloseButtonElement
    );

    this.form = this.$container.querySelector(this.$options.formElement);

    this.initListeners();
  }

  initListeners() {
    this.modalCloseButton.addEventListener('click', (event) => {
      event.preventDefault();

      this.form.submit();
      this.window.location.reload();
    });
  }
}
